module.exports = "/packs/images/homepage/facilities/extreme_mobile~14dc7809861a64ad4d6e59627f077256.jpg";